import FloorplanCarousel from "../FloorplanCarousel"

export default function FloorplanModalBody({ images }) {
  return (
    <div>
      <FloorplanCarousel images={images} />
    </div>
  )
}
